module.exports = __webpack_public_path__ + "img/upload_howitworks_choose.8247c16b.svg";